import { render, staticRenderFns } from "./svgIcon.vue?vue&type=template&id=34584f62&scoped=true&"
import script from "./svgIcon.vue?vue&type=script&lang=js&"
export * from "./svgIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34584f62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34584f62')) {
      api.createRecord('34584f62', component.options)
    } else {
      api.reload('34584f62', component.options)
    }
    module.hot.accept("./svgIcon.vue?vue&type=template&id=34584f62&scoped=true&", function () {
      api.rerender('34584f62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/svgIcon.vue"
export default component.exports